<template>
    <main role="main" class="container">
        <div class="row">
            <div class="col-md-12">
                <h3 class="pb-4 mb-4 border-bottom">
                    Дополнительные возможности - Редактирование пользователей
                </h3>
            </div>
            <aside class="col-md-4">
                <MenuComponent/>
            </aside>
            <div class="col-md-8 mb-3">
                <div v-if="users.length <= 0" class="alert alert-secondary" role="alert">
                    У Вас нет пользователей, данные которых можно редактировать
                </div>

                <div v-else>
                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <label>Пользователь для редактирования</label>
                            <select class="custom-select d-block w-100" required="" @change="selectUser()" v-model="activeUser">
                                <option value="0">Выберите...</option>
                                <option v-for="user in users" v-bind:key="user.loginId" :value="user.loginId">{{user.login}}</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label class="py-2">Имя пользователя</label>
                        </div>
                        <div class="col-md-9">
                            <input type="text" class="form-control" v-model="user.login" autocomplete="off" />
                        </div>
                        <div class="col-md-12 mb-3">
                            <small class="text-muted">Русские или латинские буквы, цифры. Возможно использование адреса EMail. Не менее трех символов.</small>
                        </div>
                        <div class="col-md-3">
                            <label class="py-2">Пароль</label>
                        </div>
                        <div class="col-md-9">
                            <input v-if="showPassword" type="text" class="form-control" v-model="user.password" autocomplete="off" />
                            <input v-else type="password" class="form-control" v-model="user.password" autocomplete="off" />
                            <i @click="passwordShow()" class="las la-eye eye"></i>
                        </div>
                        <div class="col-md-12 mb-3">
                            <small class="text-muted">Минимальная длина пароля – восемь символов. Не рекомендуем использовать пароли от других сайтов или слова, которые злоумышленники смогут легко подобрать.</small>
                        </div>
                        <div class="col-md-3">
                            <label class="py-2">E-mail</label>
                        </div>
                        <div class="col-md-9">
                            <input type="text" class="form-control" v-model="user.email" autocomplete="off" />
                        </div>
                        <div class="col-md-12 mb-3">
                            <small class="text-muted">Должен быть указан действующий адрес электронной почты. Может быть использован при восстановлении пароля.</small>
                        </div>
                    </div>
                    <h3>Установите права доступа для пользователя</h3>
                    <div class="card mb-3">
                        <div class="card-body">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" id="accGP" name="accGP" class="custom-control-input" v-model="user.accGP">
                                <label for="accGP" class="custom-control-label">Заказ Готовой продукции</label>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-3">
                        <div class="card-body">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" id="accKomplect" name="accKomplect" class="custom-control-input" v-model="user.accKomplect">
                                <label for="accKomplect" class="custom-control-label">Заказ Комплектующих</label>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-3">
                        <div class="card-body">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" id="accPriceGp" name="accPriceGp" class="custom-control-input" v-model="user.accPriceGp">
                                <label for="accPriceGp" class="custom-control-label">Просмотр цен на Готовые изделия</label>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-3">
                        <div class="card-body">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" id="accPriceKompl" name="accPriceKompl" class="custom-control-input" v-model="user.accPriceKompl">
                                <label for="accPriceKompl" class="custom-control-label">Просмотр цен на Комплектующие</label>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-3">
                        <div class="card-body">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" id="accPriceDiscount" name="accPriceDiscount" class="custom-control-input" v-model="user.accPriceDiscount">
                                <label for="accPriceDiscount" class="custom-control-label">Просмотр скидок</label>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-3">
                        <div class="card-body">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" id="accBalans" name="accBalans" class="custom-control-input" v-model="user.accBalans">
                                <label for="accBalans" class="custom-control-label">Просмотр страницы "Баланс взаиморасчетов"</label>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-3">
                        <div class="card-body">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" id="accOrders" name="accOrders" class="custom-control-input" v-model="user.accOrders">
                                <label for="accOrders" class="custom-control-label">Просмотр страницы "Состояние заказов"</label>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-3">
                        <div class="card-body">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" id="accPayGrafik" name="accPayGrafik" class="custom-control-input" v-model="user.accPayGrafik">
                                <label for="accPayGrafik" class="custom-control-label">Просмотр страницы "График платежей"</label>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-3">
                        <div class="card-body">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" id="accPayGrafikNotification" name="accPayGrafikNotification" class="custom-control-input" v-model="user.accPayGrafikNotification">
                                <label for="accPayGrafikNotification" class="custom-control-label">Получать предупреждения об оплате заказов</label>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-3" v-if="isPartner">
                        <div class="card-body">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" id="accDealerSale" name="accDealerSale" class="custom-control-input" v-model="user.accDealerSale">
                                <label for="accDealerSale" class="custom-control-label">Показывать раздел с партнерскими скидками</label>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center mb-5">
                        <div class="col-md-6" style="padding: 20px 0px;">
                            <a href="javascript:" @click="save()" class="btn btn-outline-primary btn-block">
                                Сохранить
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import MenuComponent from '../components/AdditionalFeaturesMenu';
    import rm_katris from "../js/rm_katris/app";

    // rm_katris.params.url = 'https://sale.katris.ru/proxy/AI_HELPER_45745673029734/'; //debug ONLY

    export default {
        name: "ManageUsers",
        metaInfo: {
            title: 'Редактирование пользователей',
            titleTemplate: '%s - sale.katris'
        },
        data() {
            return {
                users: [],
                activeUser: 0,
                user: {
                    'token': this.$session.get('jwt'),
                    login: '',
                    password: '',
                    email: '',
                    accGP: false,
                    accKomplect: false,
                    accPriceGp: false,
                    accPriceKompl: false,
                    accPriceDiscount: false,
                    accBalans: false,
                    accOrders: false,
                    accPayGrafik: false,
                    accPayGrafikNotification: false,
                    accDealerSale: false,
                    usertoedit: 0
                },
                showPassword: false,
                isPartner: false
            }
        },
        created() {
            let self = this;

            rm_katris.params.url = 'https://sale.katris.ru/proxy/';
            rm_katris.params.session = this.$session.get('user');
            rm_katris.user = this.$session.get('user');

            if (rm_katris.user.Deal == 1) {
                self.isPartner = true
            }

            rm_katris.makePost('katrisService', 'getUsersList', {'token': this.$session.get('jwt')}, null, function(response) {
                if (response.status === 'OK') {
                    self.users = response.data;
                }
            });
        },
        components: {
            MenuComponent
        },
        methods: {
            passwordShow: function() {
                this.showPassword = !this.showPassword;
            },
            selectUser() {
                let self = this;
                rm_katris.makePost('katrisService', 'getUserChild', {'token': this.$session.get('jwt'), 'user': self.activeUser}, null, function(response) {
                    console.log(response)
                    if (response.status === 'OK') {
                        for (let rule in response.data) {
                            if (["accBalans", "accChPayers", "accElse", "accGP", "accKomplect", "accOrders", "accOrdersOtherPayers", "accPayGrafik", "accPayGrafikNotification", "accPrice", "accPriceDiscount", "accPriceGp", "accPriceKompl", "accDealerSale"].indexOf(rule) != -1) {
                                if (response.data[rule] == 1) {
                                    response.data[rule] = true;
                                } else if (response.data[rule] == 0) {
                                    response.data[rule] = false;
                                }
                            }
                        }
                        self.user = response.data;
                        console.log(self.user)
                        self.user.usertoedit = response.data.loginId;
                        self.user.token = self.$session.get('jwt');
                    }
                });
            },
            save: function() {
                if (this.user.login != '' && this.user.password != '' && this.user.email != '' && this.user.usertoedit != 0) {
                    rm_katris.makePost('katrisService', 'newUser', this.user, null, function(response) {
                        console.log(response);
                        if (response.status === 'OK') {
                            if (response.data.error) {
                                let errors = '';
                                for (let error in response.data.error) {
                                    errors += response.data.error[error] + ' ';
                                }
                                alert(errors);
                            } else {
                                alert(response.data);
                            }
                        } else {
                            alert('Ошибка');
                        }
                    });
                } else {
                    alert('Не все поля заполнены!');
                }
            }
        }
    }
</script>

<style scoped>
    .eye {
        position: absolute;
        right: 25px;
        font-size: 24px;
        color: darkslategrey;
        top: 7px;
    }
</style>
